<script>
export default {
    methods: {
        async getUnitBrakeCheck(unitId) {
            try {
                this.$wait.start('loading brake check');
                const response = await this.$api.get(`brake-checks/unit/${unitId}`);
                return response.data;
            } catch (err) {
                if (err.response.status == 404) {
                    return null;
                }
                this.$toast.error('There was an error getting brake check');
                return null;
            } finally {
                this.$wait.end('loading brake check');
            }
        },
        async updateBrakeCheck(update) {
            try {
                this.$wait.start('loading brake check');
                const response = await this.$api.put(`brake-checks/${update.id}`, update);
                this.$toast.success(`Brake Check updated`);
                return response;
            } catch (err) {
                this.$toast.error(`Could not update Brake Check`);
                return null;
            } finally {
                this.$wait.end('loading brake check');
            }
        },
        async setBrakeCheckSchedule(update) {
            try {
                this.$wait.start('loading brake check');
                const response = await this.$api.post(`brake-checks/${update.id}`, update);
                this.$toast.success(`Brake Check updated`);
                return response;
            } catch (err) {
                this.$toast.error(`Could not update Brake Check`);
                return null;
            } finally {
                this.$wait.end('loading brake check');
            }
        },
        async getBrakeChecks(garageId, from, to) {
            try {
                this.$wait.start('loading brake checks');
                const response = await this.$api.get(`brake-checks/weekly/${garageId}?from=${from}&to=${to}`);
                return response.data;
            } catch (err) {
                this.$toast.error(`Could not get Brake Checks`);
                return null;
            } finally {
                this.$wait.end('loading brake checks');
            }
        },
        async completeBrakeChecks(garageId, data) {
            try {
                this.$wait.start('completing brake checks');
                await this.$api.post(`brake-checks/${garageId}/complete`, { brakeChecks: data });
                this.$toast.success(`Brake Checks completed`);
                return true;
            } catch (err) {
                this.$toast.error(`Could not complete Brake Checks`);
                return false;
            } finally {
                this.$wait.end('completing brake checks');
            }
        },
        async generateReport(garageId, date) {
            try {
                this.$wait.start('generating brake check form');
                const response = await this.$api.post(`brake-checks/generate`, { garageLocationId: garageId, friday: date });
                return response.data;
            } catch (err) {
                this.$toast.error(`Could not generate Brake Check form`);
                return false;
            } finally {
                this.$wait.end('generating brake check form');
            }
        }
    }
};
</script>
